import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {TableColumn} from './TableColumn';
import {Placeholder} from './PlaceHolder';
import {ButtonStyle} from './Table.styled';
import {TableRows} from './TableRows';
import {TableRow} from './TableRow';

export const LoadMorePlaceholder = ({isVisible, autoload, loading, loadMore, columns, level}) => {
	useEffect(() => {
		if (isVisible && autoload) loadMore();
	}, [isVisible]);

	let loadButton = null;
	if (!autoload) {
		loadButton = (
			<div
				key="load-more-button"
				style={{
					zIndex: 11,
					position: 'absolute',
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<ButtonStyle onClick={loadMore}>{loading ? 'Loading' : 'Load More'}</ButtonStyle>
			</div>
		);
	}

	const data = {rows: [0, 1, 2]};

	return (
		<div key="load-more-placeholder" style={{position: 'relative'}}>
			<TableRows data={data} level={level} disableVirtualization={true}>
				{({rowData, tableColumnsProps}) => (
					<TableRow {...tableColumnsProps}>
						{columns.map((_, columnIndex) => (
							<TableColumn key={`load-more-cell-${rowData}-${columnIndex}`}>
								<Placeholder animate={autoload || loading} width={60} height={10} />
							</TableColumn>
						))}
					</TableRow>
				)}
			</TableRows>
			{loadButton}
		</div>
	);
};

LoadMorePlaceholder.propTypes = {
	isVisible: PropTypes.bool,
	autoload: PropTypes.bool,
	loading: PropTypes.bool,
	loadMore: PropTypes.func,
	columns: PropTypes.any,
	level: PropTypes.number,
};
